export default __webpack_public_path__ + "static/media/M3 - Desert Whale.5e50a5a6.png";